__turbopack_context__.v({
  "accordion": "V3pCDW_accordion",
  "bottomBorder": "V3pCDW_bottomBorder",
  "content": "V3pCDW_content",
  "header": "V3pCDW_header",
});
